var _excluded = ["activeIcon", "className", "disabled", "icon", "onClick", "style"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from "../../styleguide";
var Inactive = styled.span.withConfig({
  displayName: "IconButton__Inactive",
  componentId: "sc-slrzzc-0"
})(["display:block;line-height:0;"]);
var Active = styled.span.withConfig({
  displayName: "IconButton__Active",
  componentId: "sc-slrzzc-1"
})(["display:none;line-height:0;"]);
var Button = styled.button.withConfig({
  displayName: "IconButton__Button",
  componentId: "sc-slrzzc-2"
})(["&:active{& ", "{display:none;}& ", "{display:block;}}&:disabled{& ", "{display:block;}& ", "{display:none;}}cursor:", ";-webkit-tap-highlight-color:transparent;display:flex;justify-content:center;align-items:center;"], Inactive, Active, Inactive, Active, function (props) {
  return props.disabled ? 'default' : 'pointer';
});

var IconButton = function IconButton(_ref) {
  var activeIcon = _ref.activeIcon,
      className = _ref.className,
      disabled = _ref.disabled,
      icon = _ref.icon,
      onClick = _ref.onClick,
      style = _ref.style,
      other = _objectWithoutProperties(_ref, _excluded);

  var theIcon = disabled ? /*#__PURE__*/React.cloneElement(icon, {
    color: colors.grey400
  }) : icon; // iOS won't recognise tap highligth color unless ontouchstart is present on the button

  return /*#__PURE__*/React.createElement(Button, _extends({
    style: style,
    className: className,
    type: "button",
    disabled: disabled,
    onClick: onClick,
    onTouchStart: function onTouchStart() {}
  }, other), /*#__PURE__*/React.createElement(Inactive, null, theIcon), /*#__PURE__*/React.createElement(Active, null, activeIcon));
};

IconButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The icon to use for the pressed state
   */
  activeIcon: PropTypes.node.isRequired,

  /**
   * Class name
   */
  className: PropTypes.string,

  /**
   * Disable the button
   */
  disabled: PropTypes.bool,

  /**
   * The icon to use for the default state
   */
  icon: PropTypes.node.isRequired,

  /**
   * Callback to run on the click event
   */
  onClick: PropTypes.func.isRequired,

  /**
   * Additional styling of the `button` element
   */
  style: PropTypes.object
} : {};
export default IconButton;
//# sourceMappingURL=IconButton.js.map